<template>
  <b-card class="mb-3">
    <b-row align-v="center">
      <b-col sm="8">
        <router-link
          :to="'/manage/events/' + event.id"
          class="fs-bold text-primary text-decoration-none d-block fs-5"
        >
          {{ event.name
          }}<template v-if="event.location">
            - {{ event.location.name }}</template
          >
        </router-link>
        <div class="text-muted">
          <span class="mr-3" v-b-tooltip.hover title="Looptijd van evenement">
            <font-awesome-icon icon="calendar" class="mr-1" />
            <template v-if="isSameDay(event)">
              {{ getStartDate(event) | formatTextDateTime }}
            </template>
            <template v-else>
              {{ getStartDate(event) | formatTextDateTime }} -
              {{ getEndDate(event) | formatTextDateTime }}
            </template>
          </span>
          <span class="mr-3" v-b-tooltip.hover title="Aantal tijdsloten">
            <font-awesome-icon icon="clock" class="mr-1" />
            {{ event.total_slots }}
          </span>
          <span class="mr-3" v-b-tooltip.hover title="Tickets beschikbaar">
            <font-awesome-icon icon="ticket" class="mr-1" />
            <template v-if="event.total_available_unlimited">
              Onbeperkt
            </template>
            <template v-else>
              {{ event.total_available - event.total_sold }}
            </template>
          </span>
          <span class="mr-3" v-b-tooltip.hover title="Tickets verkocht">
            <font-awesome-icon icon="ticket" class="mr-1" />
            {{ event.total_sold }}
          </span>
        </div>
      </b-col>
      <b-col sm="4">
        <div class="float-right">
          <b-badge class="bg-danger mr-2" v-if="event.canceled_at">
            Geannuleerd
          </b-badge>
          <b-badge class="bg-success mr-2" v-else-if="event.published_at">
            Published
          </b-badge>
          <b-badge class="bg-warning mr-2" v-else> Concept </b-badge>
          <template v-if="showDuplicate && (isAdmin() || isManager())">
            <b-button
              :to="'/manage/events/' + event.id + '/duplicate'"
              variant="white"
              class="text-secondary"
              v-b-tooltip.hover
              title="Dupliceer"
            >
              <font-awesome-icon icon="fa-solid fa-clone" />
            </b-button>
          </template>
          <b-button
            :to="'/manage/events/' + event.id"
            variant="white"
            class="text-secondary"
            v-b-tooltip.hover
            title="Dashboard"
          >
            <font-awesome-icon icon="fa-solid fa-chevron-right" />
          </b-button>
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import moment from "moment";
import { mapActions } from "pinia";
import { useShopStore } from "@/stores/shop";

export default {
  computed: {},
  props: {
    event: Object,
    showDuplicate: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    ...mapActions(useShopStore, ["setLoading", "isAdmin"]),
    isSameDay(event) {
      let start = this.getStartDate(event);
      let end = this.getEndDate(event);
      if (moment(start).isSame(end, "day")) {
        return true;
      }
      return false;
    },
    getStartDate(event) {
      let start_at = null;
      if (event.slots && event.slots.length > 0) {
        event.slots.forEach((item) => {
          if (start_at == null || moment(item.start_at) < moment(start_at)) {
            start_at = item.start_at;
          }
        });
        return start_at;
      }
      return null;
    },
    getEndDate(event) {
      let end_at = null;
      if (event.slots && event.slots.length > 0) {
        event.slots.forEach((item) => {
          if (end_at == null || moment(item.end_at) > moment(end_at)) {
            end_at = item.end_at;
          }
        });
        return end_at;
      }
      return null;
    },
    isAdmin() {
      return localStorage.getItem("role") == "administrator" ? true : false;
    },
    isManager() {
      return localStorage.getItem("role") == "manager" ? true : false;
    },
  },
  created() {},
};
</script>
